
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 507.996 507.996"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M49.2 225.488h81.9v16.4H49.2zM49.2 274.688h122.9v16.4H49.2zM49.2 323.888h295v16.4h-295zM49.2 372.988h49.2v16.4H49.2zM131.1 372.988h49.2v16.4h-49.2zM213.1 372.988h49.2v16.4h-49.2zM336 217.288c-6 0-11.5 1.7-16.3 4.5-5-2.9-10.6-4.5-16.5-4.5-18.1 0-32.8 14.7-32.8 32.8 0 18.1 14.7 32.8 32.8 32.8 5.9 0 11.5-1.6 16.5-4.5 4.8 2.8 10.3 4.5 16.3 4.5 18.1 0 32.8-14.7 32.8-32.8s-14.7-32.8-32.8-32.8zm-28.6 48.6c-1.4.4-2.8.6-4.2.6-9 0-16.4-7.4-16.4-16.4 0-9 7.4-16.4 16.4-16.4 1.4 0 2.9.3 4.2.6-2.6 4.7-4.2 10-4.2 15.8 0 5.8 1.6 11.1 4.2 15.8zm28.6.6c-9 0-16.4-7.4-16.4-16.4 0-9 7.4-16.4 16.4-16.4s16.4 7.4 16.4 16.4c0 9-7.4 16.4-16.4 16.4z"}}),_c('path',{attrs:{"d":"M490.9 179.388l-343.8-108.6c-2.4-.8-21.6-7.1-30.8 16l-28.3 89.5H24.6c-13.6.1-24.6 11.1-24.6 24.6v213.1c0 13.6 11 24.6 24.6 24.6h360.6c8.6 0 16.1-4.4 20.5-11.1 0 0 11.1 3.1 13.6 3.1 10.8 0 20.2-6.9 23.4-17.2l64.2-203.2c2-6.2 3.4-25.6-16-30.8zm-368.9-56.4l168.9 53.3H182l-69.9-22.1 9.9-31.2zm-14.8 46.9l20.5 6.5h-22.5l2-6.5zm286.2 244.1h-.1c0 4.5-3.7 8.2-8.2 8.2H24.6c-4.5 0-8.2-3.7-8.2-8.2v-213.1c0-4.5 3.7-8.2 8.2-8.2h360.6c4.5 0 8.2 3.7 8.2 8.2v213.1zm33.7-5.5c-1.3 4.2-6.1 6.7-10.3 5.3l-7.1-2.2v-146.1l56.9 18-39.5 125zm44.4-140.7l-61.8-19.5v-34.4l71.7 22.6-9.9 31.3zm19.8-62.5l-4.9 15.6-77.1-24.3c-2.1-11.5-12.1-20.2-24.1-20.2h-39.9l-218.4-69 4.9-15.6c1.3-4.2 6-6.7 10.3-5.3l343.8 108.5c6.9 1.8 6 8.2 5.4 10.3z"}})])
          )
        }
      }
    